import { render } from "./ThankYou.vue?vue&type=template&id=0b59e2cf&scoped=true&ts=true"
import script from "./ThankYou.vue?vue&type=script&lang=ts"
export * from "./ThankYou.vue?vue&type=script&lang=ts"

import "./ThankYou.vue?vue&type=style&index=0&id=0b59e2cf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.2.47_vue@3.2.47_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b59e2cf"]])

export default __exports__